import React from "react";
import PropTypes from "prop-types";
import logger from "../utils/logger";
import { isRecoverableChunkLoadError } from "../utils/chunkLoadError";
import { reloadAppForUpdate } from "../serviceWorkerRegistration";

class RouteChunkBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    const isChunkError = isRecoverableChunkLoadError(error);

    logger.error("RouteChunkBoundary caught route loading error", error, {
      error_meta: {
        action: "route_chunk_render",
        recoverable: isChunkError,
      },
      app_context: {
        module: "RouteChunkBoundary",
        route: window.location.pathname,
        componentStack: errorInfo?.componentStack,
      },
    });

    if (isChunkError) {
      reloadAppForUpdate({ reason: "route_chunk_error" });
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    const { error } = this.state;

    if (error) {
      const isChunkError = isRecoverableChunkLoadError(error);

      return (
        <div className="full-screen-center px-6 text-center">
          <div className="w-full max-w-md rounded-3xl border border-[var(--color-border)] bg-[var(--color-bg-secondary)] p-6 shadow-xl">
            <div className="text-xl font-black text-[var(--color-text-primary)] tracking-tight">
              {isChunkError ? "Нужно обновить приложение" : "Не удалось открыть экран"}
            </div>
            <p className="mt-3 text-sm font-medium text-[var(--color-text-secondary)] leading-relaxed">
              {isChunkError
                ? "Приложение уже обновилось на сервере или часть файлов загрузилась не полностью. Обновите страницу, чтобы продолжить работу."
                : "Во время открытия экрана произошла ошибка. Обновите страницу и попробуйте снова."}
            </p>
            <button
              type="button"
              onClick={this.handleReload}
              className="mt-5 inline-flex h-11 items-center justify-center rounded-xl bg-[var(--color-primary)] px-5 text-sm font-black text-white shadow-lg shadow-blue-500/20 transition-transform hover:scale-[1.01] active:scale-[0.99]"
            >
              Обновить приложение
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

RouteChunkBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default RouteChunkBoundary;
